<script setup lang="js">
import ContextColors from "@/components/ContextColors.vue";
import {ref} from "vue";
import Context from "@/components/Context.vue";
import CooperateTitle from "@/components/CooperateTitle.vue";
import router from "@/router";

const hzmsbt = ref("https://cos5.51tgqj.com/techming/img/hzmsbt@2x.png");
const zlzcstq = ref("https://cos5.51tgqj.com/techming/img/zlzcstq@2x.png");
const msxxt = ref("https://cos5.51tgqj.com/techming/img/msxxt@2x.png");
const JT = ref("https://cos5.51tgqj.com/techming/img/JT@2x.png");
const btwcc = ref("https://cos5.51tgqj.com/techming/img/btwcc@2x.png");

const governmentClick=()=>{
  // this.$router.push({path:"/government"});
  router.push({path:"/government"});
}
const companyClick=()=>{
  // this.$router.push({path:"/company"});
  router.push({path:"/company"});

}
const livelihoodClick=()=>{
  // this.$router.push({path:"/livelihood"});
  router.push({path:"/livelihood"});
}


</script>


<template>
<div>
  <context-colors color="bg-[#DDDDDD]" class="flex justify-center text-center">
    <el-image :src="hzmsbt" class="w-2/3"/>
  </context-colors>
  <context>
    <div class="flex justify-center text-center">
      <el-image :src="msxxt" class="w-2/3"/>
    </div>
  </context>
  <context>
    <cooperate-title text="核心价值"></cooperate-title>
    <div class="text-white flex flex-col justify-center text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>政府侧：破解“政策落地难”，提供从决策到验收的数字化治理工具</div>
      <div class="mt-3 lg:mt-6">企业侧：解决“用工管理痛”，打造可量化ROI的降本增效方案</div>
      <div class="mt-3 lg:mt-6">民生侧：消除“资源获取障”，构建社区级创业就业微生态</div>
    </div>
  </context>
  <context>
    <cooperate-title text="合作类型"></cooperate-title>
    <div class="text-white flex justify-center items-center text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div class="flex flex-col w-fit">
        <div>1. IP设计+平台开发</div>
        <div class="mt-3 lg:mt-6">2. 阵地策划执行</div>
        <div class="mt-3 lg:mt-6">3. 委托运营服务</div>
        <div class="mt-3 lg:mt-6">4. 区域合伙人招募</div>
        <div class="mt-3 lg:mt-6">5. 活动联合承办</div>
        <div class="mt-3 lg:mt-6">6. 创业项目合作</div>
      </div>
    </div>
  </context>
  <context>
    <cooperate-title text="合作模式诊断问卷"></cooperate-title>
    <div class="text-white flex flex-col justify-center items-center text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div class="flex justify-between text-center w-full">
        <text>政府侧问卷（5题）</text>
        <text class="py-1 px-3 border" @click="governmentClick">开始诊断</text>
      </div>
      <div class="flex justify-between text-center w-full mt-2 md:mt-2 lg:mt-4">
        <text>企业侧问卷（4题）</text>
        <text class="py-1 px-3 border" @click="companyClick">开始诊断</text>
      </div>
      <div class="flex justify-between text-center w-full mt-2 md:mt-2 lg:mt-4">
        <text>民生测问卷（3题）</text>
        <text class="py-1 px-3 border " @click="livelihoodClick">开始诊断</text>
      </div>
    </div>
  </context>

  <context>
    <cooperate-title text="特色融合方案"></cooperate-title>
    <div class="text-white flex flex-col justify-center items-center text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div class="w-2/3 bg-[#FF6C00] text-white text-3xl md:text-3xl lg:text-[1.8rem]  text-center py-2 rounded-xl">
        文化挖掘
      </div>
      <div class="w-1/12 mt-2 md:mt-2 lg:mt-4">
        <el-image :src="JT" class="w-full"/>
      </div>
      <div class="w-2/3 bg-[#FF6C00] text-white text-3xl md:text-3xl lg:text-[1.8rem]  text-center py-2 rounded-xl">
        ip设计
      </div>
      <div class="w-1/12 mt-2 md:mt-2 lg:mt-4">
        <el-image :src="JT" class="w-full"/>
      </div>
      <div class="w-2/3 bg-[#FF6C00] text-white text-3xl md:text-3xl lg:text-[1.8rem]  text-center py-2 rounded-xl">
        故事开发
      </div>
      <div class="w-1/12 mt-2 md:mt-2 lg:mt-4">
        <el-image :src="JT" class="w-full"/>
      </div>
      <div class="w-2/3 bg-[#FF6C00] text-white text-3xl md:text-3xl lg:text-[1.8rem]  text-center py-2 rounded-xl">
        数字衍生
      </div>
      <div class="w-1/12 mt-2 md:mt-2 lg:mt-4">
        <el-image :src="JT" class="w-full"/>
      </div>
      <div class="w-2/3 bg-[#FF6C00] text-white text-3xl md:text-3xl lg:text-[1.8rem]  text-center py-2 rounded-xl">
        实体应用
      </div>
    </div>
  </context>

</div>
</template>

<style scoped>

</style>
